import balloonThumb from './illu-zugangs-code.jpg';
import balloonFlower from './illu-registrierung.jpg';
import balloonHeart from './illu-kurs.jpg';

export const thumb = balloonThumb;
export const flower = balloonFlower;
export const heart = balloonHeart;
